import React, { createContext, useContext, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { clearToken, getToken, isAuthenticated, setToken } from '../../config/session'
import { api } from '../../api/baseRtkqApi'

interface AuthContextValue {
  token: string | null
  loading: boolean
  login: (token: string, expiresAt?: string) => void
  logout: () => void
  isAuthenticated: () => boolean
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setTokenState] = useState<string | null>(() => getToken())
  const loading = false
  const dispatch = useDispatch()

  const login = (nextToken: string, expiresAt?: string) => {
    dispatch(api.util.resetApiState())
    setToken(nextToken, expiresAt)
    setTokenState(nextToken)
  }

  const logout = () => {
    clearToken()
    setTokenState(null)
    dispatch(api.util.resetApiState())
  }

  const value = useMemo(
    () => ({
      token,
      loading,
      login,
      logout,
      isAuthenticated,
    }),
    [token, loading]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return ctx
}
